module.exports = __webpack_public_path__ + "static/Sourcegraph-867c6a939f0eb8f27812cf3dba2d9ab6.jpg";